export enum BetterRouteState{
    ShowPopup,
    Replan
}
